import { authenticatedClient } from './util'
import { HTTP_SUCCESS } from '../helpers/utils/http-status'

const fetchUser = async () => {
    return authenticatedClient()
        .get(
            `/api/users/me?populate=referredUsers`,
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not retrieve user data`)
            }
            return res
        }).then(res => res.data)
}

const getUserRefereeDetails = async (ids: string[]) => {
    return authenticatedClient()
        .post(
            `/api/memberships/get-referee-details`,
            {
                ids,
            },
        ).then(res => {
            if (res.status !== HTTP_SUCCESS) {
                throw new Error(`Could not retrieve user data`)
            }
            return res
        }).then(res => res.data)
}

export {
    fetchUser,
    getUserRefereeDetails,
}